// Vue cookies
import VueCookies from "vue-cookies";

function isLocal() {
  return document.location.hostname == "localhost" || document.location.hostname == "0.0.0.0" || document.location.hostname == "test.olaii.com";
}

const StorageService = {
  cookieSettings: {
    expires: "3m",
    domain: ".olaii.com",
    path: "/",
    sameSite: isLocal() ? "Strict" : "None",
    secure: !isLocal(),
  },

  remove(key) {
    key = StorageService._handleKey(key);
    VueCookies.remove(key, StorageService.cookieSettings.path, StorageService.cookieSettings.domain);
  },

  save(key, value) {
    if (value === undefined) {
      StorageService.remove(key);
    } else {
      key = StorageService._handleKey(key);
      VueCookies.set(
        key,
        value,
        StorageService.cookieSettings.expires,
        StorageService.cookieSettings.path,
        StorageService.cookieSettings.domain,
        StorageService.cookieSettings.secure,
        StorageService.cookieSettings.sameSite
      );
    }
  },

  get(key) {
    key = StorageService._handleKey(key);
    return VueCookies.get(key);
  },

  _handleKey(key) {
    let newKey = String(key);
    if (process.env.VUE_APP_PRODUCTION == "false") newKey += "_dev";
    return newKey;
  },

  eventIdKey: "olaii_guestlist_event_id",
  getEvent() {
    return this.get(this.eventIdKey);
  },
  setEvent(eventId) {
    return this.save(this.eventIdKey, eventId);
  },
  removeEvent() {
    return this.remove(this.eventIdKey);
  },

  organizationIdKey: "olaii_guestlist_organization_id",
  getOrganization() {
    return this.get(this.organizationIdKey);
  },
  setOrganization(organizationId) {
    return this.save(this.organizationIdKey, organizationId);
  },
  removeOrganization() {
    return this.remove(this.organizationIdKey);
  },
};

export default StorageService;
